var React = require('react');

function NoNewMessages (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M70 50.5H70.5V50V20V19.191L69.7764 19.5528L40 34.441L10.2236 19.5528L9.5 19.191V20V50V50.5H10H70ZM10 9.5L9.77639 10.4472L39.7764 25.4472L40 25.559L40.2236 25.4472L70.2236 10.4472L70 9.5H10ZM7.5 0.5H72.5C76.3739 0.5 79.5 3.62614 79.5 7.5V52.5C79.5 56.3739 76.3739 59.5 72.5 59.5H7.5C3.62614 59.5 0.5 56.3739 0.5 52.5V7.5C0.5 3.62614 3.62614 0.5 7.5 0.5Z","stroke":"#57626B"}));
}

NoNewMessages.defaultProps = {"width":"80","height":"60","viewBox":"0 0 80 60","fill":"none"};

module.exports = NoNewMessages;

NoNewMessages.default = NoNewMessages;
